module.exports = __webpack_public_path__ + "img/claim-success-mascot.8ff9c422.png";